export const UncheckedIcon = () => (
  <svg viewBox="0 0 16 16" width="16" height="16">
    <rect x="1" y="1" width="14" height="14" rx="2" fill="none" stroke="currentColor" strokeWidth="1" />
  </svg>
);

export const CheckedIcon = () => (
  <svg viewBox="0 0 16 16" width="16" height="16">
    <rect x="0" y="0" width="16" height="16" rx="2" fill="currentColor" />
    <path d="M12.5596 5.7142C12.5596 5.87293 12.504 6.00785 12.3929 6.11896L7.27384 11.238C7.16273 11.3491 7.02781 11.4047 6.86908 11.4047C6.71035 11.4047 6.57543 11.3491 6.46432 11.238L3.50004 8.27373C3.38893 8.16262 3.33337 8.0277 3.33337 7.86897C3.33337 7.71024 3.38893 7.57532 3.50004 7.46421L4.30956 6.65469C4.42067 6.54358 4.55559 6.48802 4.71432 6.48802C4.87305 6.48802 5.00797 6.54358 5.11908 6.65469L6.86908 8.41063L10.7738 4.49992C10.885 4.38881 11.0199 4.33325 11.1786 4.33325C11.3373 4.33325 11.4723 4.38881 11.5834 4.49992L12.3929 5.30944C12.504 5.42055 12.5596 5.55547 12.5596 5.7142H12.5596Z" fill="white" />
  </svg>
);

export const IndeterminateIcon = () => (
  <svg viewBox="0 0 16 16" width="16" height="16">
    <rect x="0" y="0" width="16" height="16" rx="2" fill="currentColor" />
    <line x1="4" y1="8" x2="12" y2="8" stroke="white" strokeWidth="3" />
  </svg>
);

export const RadioUncheckedIcon = () => (
  <svg viewBox="0 0 16 16" width="16" height="16">
    <circle cx="8" cy="8" r="7" fill="none" stroke="currentColor" strokeWidth="1" />
  </svg>
);

export const RadioCheckedIcon = () => (
  <svg viewBox="0 0 16 16" width="16" height="16">
    <circle cx="8" cy="8" r="7" fill="none" stroke="currentColor" strokeWidth="1" />
    <circle cx="8" cy="8 " r="4" fill="currentColor" />
  </svg>
);
